import React, { useEffect } from 'react';
import setResponseHeaders from '@buzzfeed/headers';
import FAQ from '../components/LandingPage/FAQ';
import DemoSection from '../components/LandingPage/DemoSection';
import styles from './index.module.scss';
import { useTrackingContext } from '../hooks';
import Highlights from '../components/LandingPage/Highlights';

const Page = () => {
  const { trackPageview } = useTrackingContext();

  useEffect(() => {
    trackPageview();
  }, []);

  return (
    <div className={styles.content}>
      <h1 className={styles.headerTitle}>BuzzFeed Island - Download the App</h1>
      <DemoSection />
      <Highlights />
      <FAQ />
    </div>
  );
};

export default Page;

export async function getServerSideProps({ req, res }) {
  try {
    setResponseHeaders({
      req,
      res,
      maxAge: 86400,
      contentIDs: [],
    });
    return {
      props: {
        tracking: {
          context_page_id: 'home',
          context_page_type: 'utility',
        },
      },
    };
  } catch (error) {
    if (error.status === 404) {
      return {
        notFound: true,
      };
    }

    throw error;
  }
}
